export const RadioOptionCard = ({
  label,
  selected,
  onSelect,
  testId,
}: {
  label: string;
  selected: boolean;
  onSelect: () => void;
  testId: string;
}) => (
  <button
    type="button"
    onClick={onSelect}
    className={`flex items-center justify-between w-full p-4 rounded-xl border-2 transition-colors text-left ${
      selected ? 'border-success bg-white' : 'border-stroke-secondary-subtle bg-white'
    }`}
    data-testid={testId}
  >
    <span className="typography-body text-primary">{label}</span>
    <div
      className={`size-5 rounded-full border-2 flex items-center justify-center shrink-0 ${
        selected ? 'border-success' : 'border-stroke-secondary-subtle'
      }`}
    >
      {selected && <div className="size-2.5 rounded-full bg-success" />}
    </div>
  </button>
);
